import axios from "axios";
import { API } from "./api";

const partnerApi = axios.create({ baseURL: API });

partnerApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("xch_partner_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default partnerApi;

export const partnerLogout = () => {
  localStorage.removeItem("xch_partner_token");
  localStorage.removeItem("xch_partner");
};

export const getPartner = () => {
  try { return JSON.parse(localStorage.getItem("xch_partner") || "null"); }
  catch { return null; }
};
